// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_AcK","cls2":"AuthorsCard-cls2_7P7 AuthorsCard-cls1_AcK"};